import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Reveal } from '../ui-custom/Reveal';
import { theme } from '../../utils/theme';

const ProcessStep = ({ number, title, text }) => {
  return (
    <div className="flex flex-col items-center group cursor-default">
      <div className="font-black transition-colors duration-500 group-hover:text-white/10 select-none !text-7xl mb-4 !text-[rgba(255,255,255,0.2)]">
        {number}
      </div>
      <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-orange-400 transition-colors">
        {title}
      </h3>
      <p className="text-m text-gray-500 max-w-xs leading-relaxed group-hover:text-gray-400 transition-colors">
        {text}
      </p>
    </div>);

};

export const HowItWorksSection = () => {
  const { t } = useLanguage();
  
  const steps = [
    { number: '1', title: t.howItWorks.step1Title, text: t.howItWorks.step1Text },
    { number: '2', title: t.howItWorks.step2Title, text: t.howItWorks.step2Text },
    { number: '3', title: t.howItWorks.step3Title, text: t.howItWorks.step3Text }
  ];
  
  return (
    <section
      id="economies"
      className="py-24 border-t relative bg-[#050505]"
      style={{ borderColor: theme.colors.border }}>

      <div className="max-w-7xl mx-auto px-4 text-center">
        <Reveal>
          <h2 className="text-3xl md:text-5xl font-bold mb-16 bg-clip-text text-transparent bg-gradient-to-b from-white to-gray-400">
            {t.howItWorks.title}
          </h2>
        </Reveal>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {steps.map((step, idx) =>
          <Reveal key={idx} delay={100 + idx * 200}>
              <ProcessStep {...step} />
            </Reveal>
          )}
        </div>
      </div>
    </section>);

};